import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72ae1e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal fd-about-carousel"
}
const _hoisted_2 = { class: "el-carousel__container" }
const _hoisted_3 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_4 = { class: "fd-about-wrap" }
const _hoisted_5 = { class: "fd-about-company" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("公司介绍")
const _hoisted_7 = {
  key: 0,
  class: "fd-about-company-title"
}
const _hoisted_8 = { class: "fd-about-company-content" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("申请加入俱乐部会员 ")
const _hoisted_10 = { class: "fd-about-box" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("初心 & 使命")
const _hoisted_12 = { class: "fd-about-box-list" }
const _hoisted_13 = { class: "fd-about-box-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-about-box-title" }, "融化地产家居协同发展 助推家居社区化趋势", -1))
const _hoisted_15 = { class: "fd-about-box-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-about-box-title" }, "新思维驱动家居行业新活力", -1))
const _hoisted_17 = { class: "fd-about-box-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-about-box-title" }, "社区渠道赋能闭环", -1))
const _hoisted_19 = { class: "fd-about-box" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("发展战略")
const _hoisted_21 = { class: "fd-about-box-list" }
const _hoisted_22 = { class: "fd-about-box-item" }
const _hoisted_23 = { class: "fd-about-box" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("俱乐部架构")
const _hoisted_25 = { class: "fd-about-box-list" }
const _hoisted_26 = { class: "fd-about-box-item" }
const _hoisted_27 = { class: "fd-about-box" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("咨询业务")
const _hoisted_29 = { class: "fd-about-box-list" }
const _hoisted_30 = { class: "fd-about-box-item" }

import store from "@/store/index";
import { ref, reactive } from "vue";
import Bottom from './components/bottom.vue'
import router from "@/router/index";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const srcList = [
  require('@/assets/fd/about/u662b.jpg'),
  require('@/assets/fd/about/u656b.jpg'),
  require('@/assets/fd/about/u660b.jpg'),
  require('@/assets/fd/about/u652b.jpg'),
  require('@/assets/fd/about/u664b.jpg'),
  require('@/assets/fd/about/u665b.jpg'),
]

const companyList = ref([
  {
    type: 1,
    title: '广州冠盟社区美居科技服务有限公司',
    content: '成立于2021年，是由家居、建材、物业、营销等领域资深专家团联手打造的行业智库&第三方服务公司，专注于泛家居行业社区渠道研究及社区营销赋能。泛家居行业在新零售浪潮的冲击下，正在经历着深刻的渠道变革和销售场景重塑，客源流量已成为撬动整个行业的关键杠杆，家居流量的源头在社区。“社区化+”正成为继“互联网+”之后的另一波汹涌浪潮，它将彻底改变泛家居行业的渠道和销售格局。“家居销售社区化”符合降成本、高效率、重体验等所有新零售的底层逻辑，社区渠道将是泛家居业未来营销的主渠道！公司正是基于对社区化趋势的认知和为社区美居业务服务的初心而成立，将通过社区渠道研究、社区业务模式探索、业务体系打造、社区营销赋能、行业交流融合、行业资源对接等形式，系统化推动社区美居业务的良性顺畅发展。',
    status: 1
  },
  {
    type: 2,
    logo: require('@/assets/fd/about/u693.png'),
    content: '是为了凝聚社区渠道超级资源圈而创立的一个组织。俱乐部采取会员制形式自主加入，分为地产物业、品牌厂家、社区商家及第三方服务4类会员。俱乐部以咨询、培训和活动为抓手，通过社区美居业务全案咨询、社区业务体系打造、拎包商专业培训、拎包商加盟招募、以及拎包年会、行业论坛、交流互访等方式，将4方凝聚到一个圈子里，通过合作、磨合、共识等阶段，最终顺畅相互赋能，共赢家居销售社区化大时代。',
    status: 2
  },
  {
    type: 2,
    logo: require('@/assets/fd/about/u684.png'),
    content: '是社区美居俱乐部各项业务的互联网展示平台，主要功能是社区美居俱乐部的会员之家，发布地产物业及泛家居领域的业务实况、行业信息、社区渠道业务模式探索及营销创新的成果等，达到“链接地产&家居”的初衷，促进地产与家居融为一个“圈”，为业主“住得好”的美好向往而共同努力！',
    status: 1
  },
  {
    type: 1,
    title: '社区美居数据库软件',
    content: '是社区美居网的底层支撑软件系统，是全国地产物业会员的拎包入住招商项目数据库和全国专业拎包入住经销商资料库。不管是新房项目，还是次新房、存量房项目，当物业有社区美居业务招商需求时，物业会员通过专用账号登陆社区美居网，发布招商信息，系统内的巨量会员经销商（含品牌厂家）可立即查看到该信息，感兴趣的项目可直接线上报名，物业收到信息后可联系商家线下洽谈对接。从而达到项目高效找到优质商家，商家高效找到目标项目的目的。同时物业还可以通过设定条件精准搜索到理想商家。',
    status: 1
  },
])

const bindData = reactive({
  isShowDefaultImage: true,
  defaultImage: '',
  images: [],
});
const advertisingImageEvent = () => {
  store
    .dispatch("frontIndexModule/listAdvertisingImage", { type: 5 })
    .then(
      (data) => {
        console.log(data.result);
        bindData.images = data.result;
        if (data.result.length > 0) {
          bindData.defaultImage = data.result[0];
        }
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

advertisingImageEvent();

const toMemberReg = () => {
  router.push("/frontDesk/member");
};

setTimeout(() => { bindData.isShowDefaultImage = false }, 3000);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_image, {
                class: "fd-about-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "fd-about-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "fd-about-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_container, { class: "fd-about-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "fd-about-company-list" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fd-about-company-item",
                key: index
              }, [
                (item.type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.title), 1))
                  : _createCommentVNode("", true),
                (item.type == 2)
                  ? (_openBlock(), _createBlock(_component_el_container, {
                      key: 1,
                      class: "fd-about-company-logo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_image, {
                          src: item.logo
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.content), 1),
                (item.status == 2)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      class: "fd-about-company-btn",
                      size: "large",
                      onClick: toMemberReg
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_container, { class: "fd-about-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_el_container, { class: "fd-about-box-banner" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  src: require('@/assets/fd/about/u662.jpg'),
                  "preview-src-list": srcList,
                  "initial-index": 0,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_el_container, { class: "fd-about-box-banner" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  src: require('@/assets/fd/about/u656.jpg'),
                  "preview-src-list": srcList,
                  "initial-index": 1,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_container, { class: "fd-about-box-banner" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  src: require('@/assets/fd/about/u660.jpg'),
                  "preview-src-list": srcList,
                  "initial-index": 2,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_el_container, {
          class: "fd-about-divider",
          id: "scope-of-service"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_container, { class: "fd-about-box-banner" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  src: require('@/assets/fd/about/u652.jpg'),
                  "preview-src-list": srcList,
                  "initial-index": 3,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_container, { class: "fd-about-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_el_container, { class: "fd-about-box-banner" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  src: require('@/assets/fd/about/u664.jpg'),
                  "preview-src-list": srcList,
                  "initial-index": 4,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_el_container, { class: "fd-about-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_28
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_container, { class: "fd-about-box-banner" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  src: require('@/assets/fd/about/u665.jpg'),
                  "preview-src-list": srcList,
                  "initial-index": 5,
                  fit: "cover"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})